import React, { useEffect, useRef } from 'react';

const ScrollReveal = ({ children, threshold = 0.15, delay = 0 }) => {
  const ref = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('visible');
            }, delay);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold, rootMargin: "0px 0px -50px 0px" }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold, delay]);
  return <div ref={ref} className="scroll-reveal">{children}</div>;
};
export default ScrollReveal;